import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-execution',

  templateUrl: './add-execution.component.html',
  styleUrl: './add-execution.component.css'
})
export class AddExecutionComponent implements OnInit {
  executionFrom !: FormGroup;
  selectedDomain = 'Residential'; // default
  domainOptions:any = [];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
    Residential: [
 { key: "unitConstructionRate", "label": "Unit Construction Rate", "type": "number", "required": false, "value": "5 units/week" },
  { key: "masonryMaterialUsed", "label": "Masonry Material Used", "type": "text", "required": false, "value": "Fly ash bricks" },
  { key: "flooringInstallation", "label": "Flooring Installation", "type": "text", "required": false, "value": "Vitrified tiles" },
    ],
    Commercial: [
  { key: "hvacInstallationStatus", "label": "HVAC Installation Status", "type": "text", "required": false, "value": "60% complete" },
  { key: "elevatorCommissioning", "label": "Elevator Commissioning", "type": "date", "required": false, "value": "2023-12-01" },
  { key: "facadeWorkProgress", "label": "Façade Work Progress", "type": "percentage", "required": false, "value": 75 },
    ]
    ,
    Educational: [
  { key: "classroomCompletion", "label": "Classroom Completion", "type": "number", "required": false, "value": "30 out of 50" },
  { key: "labEquipmentDelivery", "label": "Lab Equipment Delivery", "type": "date", "required": false, "value": "2023-10-15" },
  { key: "sportsFieldGrading", "label": "Sports Field Grading", "type": "text", "required": false, "value": "Levelled and compacted" },
    ]
    ,
    Water: [
{ key: "pipelineLaidLength", "label": "Pipeline Laid Length", "type": "distance", "required": false, "value": "15 km" },
  { key: "tankConstructionStatus", "label": "Tank Construction Status", "type": "percentage", "required": false, "value": 80 },
  { key: "pumpInstallationDate", "label": "Pump Installation Date", "type": "date", "required": false, "value": "2023-11-20" },
    ]
    ,
    Power: [
  { key: "cableLaidLength", "label": "Cable Laid Length", "type": "distance", "required": false, "value": "10 km" },
  { key: "transformerInstalled", "label": "Transformer Installed", "type": "number", "required": false, "value": 3 },
  { key: "substationTestingDate", "label": "Substation Testing Date", "type": "date", "required": false, "value": "2023-12-10" },
    ]
    ,
    Gas: [
 { key: "pipelineWeldCount", "label": "Pipeline Weld Count", "type": "number", "required": false, "value": 250 },
  { key: "pressureTestStatus", "label": "Pressure Test Status", "type": "text", "required": false, "value": "Passed" },
  { key: "safetyDrillFrequency", "label": "Safety Drill Frequency", "type": "text", "required": false, "value": "Monthly" },
    ]
    ,
    Telecom: [
{ key: "towerErectionStatus", "label": "Tower Erection Status", "type": "text", "required": false, "value": "Completed" },
  { key: "fiberCablePulledLength", "label": "Fiber Cable Pulled Length", "type": "distance", "required": false, "value": "80 km" },
  { key: "signalTestingDate", "label": "Signal Testing Date", "type": "date", "required": false, "value": "2023-12-05" },
    ]
    ,
    Road: [
       { key: "asphaltLaidArea", "label": "Asphalt Laid Area", "type": "area", "required": false, "value": "50,000 sq m" },
  { key: "laneMarkingStatus", "label": "Lane Marking Status", "type": "percentage", "required": false, "value": 60 },
  { key: "culvertInstallation", "label": "Culvert Installation", "type": "number", "required": false, "value": 12 },
    ]
    ,
    Consultancy: [
  { key: "siteVisitFrequency", "label": "Site Visit Frequency", "type": "text", "required": false, "value": "Bi-weekly" },
  { key: "executionReviewNotes", "label": "Execution Review Notes", "type": "text", "required": false, "value": "Phase 1 completed" },
  { key: "complianceAuditStatus", "label": "Compliance Audit Status", "type": "text", "required": false, "value": "In progress" }
    ]

  };


  commonFields = [
    { key: "projectName", "label": "Project Name", "type": "text", "required": true, "value": "SigmaTConflux Infrastructure Project" },
    { key: "projectId", "label": "Project ID", "type": "number", "required": true, "value": 12345 },
    { key: "executionLead", "label": "Execution Lead", "type": "text", "required": true, "value": "Suresh Menon" },
    { key: "executionStartDate", "label": "Execution Start Date", "type": "date", "required": true, "value": "2023-07-01" },
    { key: "executionEndDate", "label": "Execution End Date", "type": "date", "required": true, "value": "2024-01-15" },
    { key: "contractorName", "label": "Contractor Name", "type": "text", "required": true, "value": "BuildPro Pvt Ltd" },
    { key: "workBreakdownStructure", "label": "Work Breakdown Structure", "type": "text", "required": true, "value": "Phase-wise task list" },
    { key: "dailyProgressLogRef", "label": "Daily Progress Log Ref", "type": "text", "required": true, "value": "EXEC-LOG-2023-001" },
    { key: "safetyProtocols", "label": "Safety Protocols", "type": "text", "required": true, "value": "PPE, Fire Safety, Emergency Response" },
    { key: "qualityControlMethod", "label": "Quality Control Method", "type": "text", "required": true, "value": "ISO 9001, Site Inspections" },
    { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) }
  ];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

  ngOnInit(): void {
    this.executionFrom = this.fb.group({});
    this.commonFields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      this.executionFrom.addControl(field.key, this.fb.control(field.value || '', validators));
    });
    this.onDomainChange(this.selectedDomain);
  }



  onSubmit() {
    if (this.executionFrom.valid) {
      console.log(this.executionFrom.value);
    }
  }
  onReset(): void {
    this.executionFrom.reset();
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.executionFrom.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.executionFrom.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.executionFrom.addControl(field.key, this.fb.control(field.value));
    });

  }

}
